'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002419 from "./presto.-Agent-View$$anon$19.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$18() {
  this.awy = null;
  this.awq = null;
  this.awr = false;
  this.awz = null;
  this.awA = false;
  this.awD = null;
  this.aww = null;
  this.awx = false;
  this.aws = null;
  this.awt = false;
  this.awu = null;
  this.awv = false;
  this.awB = false;
  this.awC = false;
  this.awy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awD = "LocalPjeOfficeCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$18 as $c_Lpresto_AgentView$$anon$18 };
$p = $c_Lpresto_AgentView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$18;
/** @constructor */
function $h_Lpresto_AgentView$$anon$18() {
}
export { $h_Lpresto_AgentView$$anon$18 as $h_Lpresto_AgentView$$anon$18 };
$h_Lpresto_AgentView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.awy;
});
$p.M = (function() {
  if ((!this.awr)) {
    this.awq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awr = true;
  }
  return this.awq;
});
$p.O = (function() {
  if ((!this.awA)) {
    this.awz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awA = true;
  }
  return this.awz;
});
$p.E = (function() {
  return this.awD;
});
$p.t = (function() {
  if ((!this.awx)) {
    this.aww = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awx = true;
  }
  return this.aww;
});
$p.N = (function() {
  if ((!this.awt)) {
    this.aws = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awt = true;
  }
  return this.aws;
});
$p.Q = (function() {
  if ((!this.awv)) {
    this.awu = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002419.$c_Lpresto_AgentView$$anon$19();
    this.awv = true;
  }
  return this.awu;
});
$p.v = (function() {
  if ((!this.awC)) {
    this.awB = false;
    this.awC = true;
  }
  return this.awB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee120) => ((p) => \u03b4scrutinee120.cFi(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$18, "presto.AgentView$$anon$18", ({
  DE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$18 as $d_Lpresto_AgentView$$anon$18 };
//# sourceMappingURL=presto.-Agent-View$$anon$18.js.map
